import PropTypes from 'prop-types';
import Modal from '../Common/Modal';
import Button from '../Common/Button';

const DeleteRoleConfirmModal = ({
  isOpen,
  onClose,
  role,
  onConfirm,
  deleting = false,
}) => {
  const roleName = role?.name || 'this role';

  return (
    <Modal
      isOpen={isOpen}
      onClose={deleting ? () => {} : onClose}
      title="Delete role"
      size="small"
      content={
        <div className="px-4 py-3 space-y-3">
          <p className="text-sm text-[#6B7C93] dark:text-[#8FA3B8]">
            Are you sure you want to delete{' '}
            <b className="text-[#0A2342] dark:text-white">{roleName}</b>?
          </p>
          {role?.description ? (
            <p className="text-xs text-[#6B7C93] dark:text-[#8FA3B8]">{role.description}</p>
          ) : null}
          <p className="text-xs text-[#6B7C93] dark:text-[#8FA3B8]">
            Users already assigned this role will keep the role name. This action cannot be undone.
          </p>
        </div>
      }
      actions={
        <div className="flex items-center gap-2">
          <Button variant="secondary" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={deleting}
            className="!bg-red-600 hover:!bg-red-700 focus:!ring-red-300 dark:!bg-red-600 dark:hover:!bg-red-700"
          >
            {deleting ? 'Deleting...' : 'Delete role'}
          </Button>
        </div>
      }
    />
  );
};

DeleteRoleConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  role: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  deleting: PropTypes.bool,
};

DeleteRoleConfirmModal.defaultProps = {
  role: null,
  deleting: false,
};

export default DeleteRoleConfirmModal;
